import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import './index.css';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import { registerServiceWorker } from './lib/push';
// Client error reporter (2026-09-22, Jaime): global window error + unhandled
// rejection reporting to /api/client-errors (fire-and-forget, never throws).
import { installGlobalErrorReporters } from './lib/clientErrorReporter';
import VpDebugChip from './components/VpDebugChip';
import './i18n';
import { traceSel } from './utils/selTrace';

installGlobalErrorReporters();

// TH1 diagnostic lane (2026-09-30): boot tag with the SW cache names + build
// SHA, so a captured trace proves which bundle/cache the session ran on.
const __bootSha = typeof __BUILD_SHA__ !== 'undefined' ? __BUILD_SHA__ : 'unknown';
if ('caches' in window) {
  caches.keys()
    .then((keys) => traceSel('boot', { swCaches: keys, buildSha: __bootSha }))
    .catch(() => traceSel('boot', { swCaches: null, buildSha: __bootSha }));
} else {
  traceSel('boot', { swCaches: null, buildSha: __bootSha });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <App />
        <VpDebugChip />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Web-push infra (2026-09-17) + offline shell (G1, peer review of 0992166):
// register the service worker UNCONDITIONALLY at bootstrap so the offline shell
// installs for every user — not only users who granted notification permission
// (the Jaime directive: the app must always open offline). Permission is still
// requested later (after login, one-time prompt in PushNotificationSetup);
// registration is memoized/idempotent in registerServiceWorker, so the push
// flows reuse this same registration.
registerServiceWorker();
